<template>
  <div class="sync">
    <el-dialog
      :close-on-click-modal="false"
      title="店铺信息"
      width="800px"
      :visible.sync="visible"
      :before-close="handleClose"
    >
      <el-table
        ref="multipleTable"
        :data="shopList"
        class="sync-table"
        @selection-change="handleSelectionChange"
        height="360"
      >
        <el-table-column
          :selectable="checkSelectable"
          type="selection"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="platNo" label="平台渠道">
          <template slot-scope="scope">
            <div>{{ dictMap["plat_no"][scope.row.platNo] }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="shopName" label="店铺名称">
          <template slot-scope="scope">
            <div>
              {{ scope.row.shopName }}（
              <span v-if="scope.row.isExpire && scope.row.authStatus == '02'">
                已过期
              </span>
              <span
                :style="{
                  color: scope.row.authStatus == '02' ? '#00b78d' : 'inherit',
                }"
                v-else
                >{{ dictMap["auth_status"][scope.row.authStatus] }}</span
              >）
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">返回</el-button>
        <el-button type="primary" @click="sureImport" size="small">
          确定
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="同步产品"
      width="40%"
      class="sync-order"
      :visible.sync="loadingVisible"
    >
      <el-progress
        :text-inside="true"
        :stroke-width="24"
        :percentage="percent"
        status="success"
      ></el-progress>
      <div class="status">
        状态：
        <span class="red">
          {{
            percent >= 100
              ? successFlag
                ? "已完成!" + (this.showMessage ? "(" + this.message + ")" : "")
                : "同步失败"
              : "进行中..."
          }}
        </span>
      </div>
      <div class="detail" v-if="resultList.length > 0">
        详情：
        <div class="detail-wrap">
          <div class="list" v-for="(item, index) in resultList" :key="index">
            {{ item.name }}，
            {{ item.status === "success" ? "同步成功！" : "同步失败！" }}
            <span :class="item.status === 'success' ? '' : 'red'">
              {{
                item.status === "success"
                  ? `共成功同步${item.count}条数据！`
                  : `失败原因：${item.reason}`
              }}
            </span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose" size="small">
          关闭
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getShopList } from "@/api/system/shopManage"
import { syncOrder } from "@/api/order/all"
import { mapGetters } from "vuex"
import { getProductList, syncByShop } from "@/api/order/lazada"
import { syncByShopShopee } from "@/api/order/shopee"
import { syncByShopTiktok } from "@/api/order/tiktok"

export default {
  name: "SyncOrder",
  data() {
    return {
      shopList: [],
      multipleSelection: [],
      percent: 0,
      loadingVisible: false,
      resultList: [],
      timer: null,
      successFlag: false,
      message: "数据可能延迟，请稍后刷新",
      showMessage: false,
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    platNo: {
      type: String,
      default() {
        return "04"
      },
    },
    isSyncProduct: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  watch: {
    visible() {
      if (this.visible) {
        this.showMessage = false
        this.successFlag = false
        this.percent = 0
        this.getData()
      }
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  mounted() {},
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    checkSelectable(row) {
      return row.authStatus == "02" && !row.isExpire
    },
    getData() {
      getShopList({ platNo: this.platNo, authStatus: "02" }).then((res) => {
        let array = res.rows.filter((record) => {
          if (record.platNo == "04") {
            return record.amazonAccount != null
          } else if (record.platNo == "03") {
            return record.platNo == "03"
          } else {
            return true
          }
        })
        this.shopList = array
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleClose() {
      this.$emit("onClose")
      this.$emit("update")
      this.loadingVisible = false
    },
    completeDate(value) {
      return value < 10 ? "0" + value : value
    },
    sureImport() {
      const ids = []
      const now = new Date()
      const year = now.getFullYear() // 得到年份
      const month = now.getMonth() + 1 // 得到月份
      const date = now.getDate() // 得到日期
      this.multipleSelection.map((el) => {
        ids.push(el.shopId)
      })
      if (ids.length == 0) {
        this.msgError("请选择店铺")
        return
      }

      this.$emit("onClose")
      // this.loadingVisible = true

      // this.timer = setInterval(() => {
      //   if (this.percent < 100) {
      //     this.percent += 2
      //   }
      // }, 1000)

      let syncMethod = syncOrder

      if (this.platNo == "03") {
        syncMethod = syncByShop
      }
      if (this.platNo == "05") {
        syncMethod = syncByShopShopee
      }
      if (this.platNo == "10") {
        syncMethod = syncByShopTiktok
      }
      this.events.$emit("showSyncHint", true)

      syncMethod({
        orderDate: `${year}-${this.completeDate(month)}-${date}`,
        shopIds: ids.join(","),
        shopId: ids.join(","),
      })
        .then((res) => {
          this.percent = 100
          if (res.code == 200) {
            this.successFlag = true
            this.msgSuccess(res.msg)
          } else {
            this.successFlag = false
            this.msgError(res.msg)
          }
          this.$emit("update")
          // clearInterval(this.timer)
          this.events.$emit("showSyncHint", false)
        })
        .catch((error) => {
          this.successFlag = true
          this.showMessage = true
          this.percent = 100
          // clearInterval(this.timer)
          this.events.$emit("showSyncHint", false)
        })
    },
  },
}
</script>

<style scoped>
.sync /deep/.el-table::before {
  display: none;
}
.sync-table {
  overflow-y: auto;
  max-height: 260px;
}
.status {
  margin: 10px 0;
}
.red {
  color: red;
}
.detail-wrap {
  max-height: 180px;
  overflow-y: auto;
}
.detail .list {
  padding: 5px 20px;
  box-sizing: border-box;
  width: 100%;
}
</style>
